import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
import { Checkbox } from "../primitives/Checkbox.js";
export function FilterGroup({ title, options, selected, onChange, className, }) {
    const toggle = (v) => {
        if (selected.includes(v))
            onChange(selected.filter((x) => x !== v));
        else
            onChange([...selected, v]);
    };
    return (_jsxs("fieldset", { "data-slot": "filter-group", className: cn("flex flex-col gap-2", className), children: [_jsx("legend", { className: "text-overline font-semibold uppercase tracking-[0.014em] text-ink-500", children: title }), _jsx("div", { className: "flex flex-col gap-1.5", children: options.map((o) => (_jsxs("div", { className: "flex items-center justify-between", children: [_jsx(Checkbox, { checked: selected.includes(o.value), onChange: () => toggle(o.value), label: o.label }), o.count !== undefined ? (_jsx("span", { className: "text-caption text-ink-400", children: o.count })) : null] }, o.value))) })] }));
}
